import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.public.notes.edit', {
        url: '/:noteId/edit',
        resolve: {
            noteId,
            note,
        },
        views: {
            '@user': 'userPublicNotesEdit',
        },
    });
}

/** @ngInject */
function noteId($stateParams) {
    return $stateParams.noteId;
}

/** @ngInject */
function note(noteId, notes) {
    let note = notes.find(note => note.id === noteId);
    return notes.find(note => note.id === noteId);
}



// WEBPACK FOOTER //
// ./src/portal/states/user/notes/edit/edit-note.state.js